export default "__VITE_ASSET__SSD8u929__"